import React, {useContext, useLayoutEffect, useState} from 'react';
import {View, Pressable, LayoutChangeEvent} from 'react-native';
import AsyncStorage from "@react-native-async-storage/async-storage";
import MainStyle from "../../../../../../MainStyle";
import Button from "../../../../../components/Button";
import {StoreContext} from "../../../../../components/StoreContextProvider";
import Checkbox from "../../../../../components/Checkbox";
import {useNavigation} from "@react-navigation/native";
import ServiceClient from "../../../../../utils/ServiceClient";
import TermsAndConditionsContent from '../../../../TermsAndConditionsScreen/TermsAndConditionsContent';
import {colors} from "../../../../../assets/styles/colors";
import {BrandName, isFullSwing, StartingPage, WebAppText} from "../../../../../constants";
import Div from "../../../../../lib/Div";
import P from "../../../../../lib/P";
import Btn from "../../../../../components/Btn";

type Props = { goNext: () => void, goBack: () => void };

const TermsConditions = (props: Props) => {
  const [isChecked, setIsChecked] = useState(false);
  const Context = useContext(StoreContext);
  const {cancelModalConfig, session} = Context;
  const navigation: any = useNavigation();
  const [height, setHeight] = useState(0);
  const [step, setStep] = useState(1);

  const onLayout = (event: LayoutChangeEvent) => {
    setHeight(event.nativeEvent.layout.height);
  };

  const onResume = () => {
    Context.setCancelModalConfig({...cancelModalConfig, visible: false});
  };

  const AcceptTnc = () => {
    if (step === 1 && (isFullSwing || isChecked)) {
      setIsChecked(false);
      setStep(2);

    } else if (step === 2 && (isFullSwing || isChecked)) {
      Context.setLoadingOverlay(true);

      ServiceClient.acceptTnc().then(() => {
        Context.setLoadingOverlay(false);
        props.goNext();

      }).catch(err => {
        console.log('acceptTnc err', err);
        Context.setLoadingOverlay(false);

        if (err && err.message) {
          Context.setCancelModalConfig({
            visible: true, subtitle: err.message, onExit: onResume, title: 'Error', leftBtnText: 'OK'
          });
        }
      });

    } else {
      Context.setCancelModalConfig({
        visible: true, subtitle: 'You need to accept TERMS & CONDITIONS', onExit: onResume, title: 'Error',
        leftBtnText: 'OK'
      });
    }
  };

  useLayoutEffect(() => {
    (async () => {
      if (!session) {
        const val = await AsyncStorage.getItem('session');

        if (val) {
          const session = JSON.parse(val);
          Context.setSession(session);

        } else {
          navigation.reset({index: 0, routes: [{name: StartingPage}]});
        }
      }
    })();
  }, []);

  return (
    <Div flex={1} mx={20}>
      <P fw="500" fs={isFullSwing ? 16 : 30} lh={24} ta="center" mb={isFullSwing ? 10 : 59}
         fontFamily={isFullSwing ? 'DavisSans-Medium' : undefined}>
        {step === 1 ? 'Terms & Conditions' : 'Health Information and Biometric Consent'}
      </P>

      <View style={[MainStyle.min_h_164, isFullSwing ? MainStyle.m_b_70 : MainStyle.m_b_37, MainStyle.flex1]}
            onLayout={onLayout}>
        {!!height && (
          <>
            {step === 1 ? (
              <>
                <TermsAndConditionsContent height={height}/>
              </>
            ) : (
              <Div maxW={1120} mx="auto" px={20}>
                <P fw="700" fs={14} mb={21} tt="uppercase">
                  As part of participating in {BrandName}, we ({BrandName} Inc. dba {BrandName}) and our service
                  providers collect certain health information, namely, facial recognition biometrics. We use this
                  information to provide you with our services, including to verify your identity and for fraud
                  prevention purposes. We will retain your biometric identifier locally for 30 days and on our servers
                  for 7 years. For more information on our data processing practices and any rights you may have, please
                  see our Privacy Policy at <P fw="700" fs={14} tt="uppercase" color={colors.lightBlue}
                                               onPress={() => navigation.navigate('PrivacyPolicy')}>{WebAppText}/privacy</P>.
                  Please note that Topgolf International, Inc. does not control or receive your biometric information.
                </P>
              </Div>
            )}
          </>
        )}
      </View>

      {!isFullSwing && (
        <Pressable style={[MainStyle.row, MainStyle.m_b_40, MainStyle.m_l_20, MainStyle.a_i_c]}
                   onPress={() => setIsChecked(!isChecked)}>
          <Checkbox value={isChecked} size={18} onValueChange={() => setIsChecked(!isChecked)}/>
          <P fw="500" ml={17}>
            {step === 1 ? 'I have read and agree to all Terms and Conditions' : `Collection and Use. By checking this box and clicking “Next”, I consent to ${BrandName} collecting and using my biometric information to participate in ${BrandName} services and to the ${BrandName} Terms of Service at ${WebAppText}/termsandconditions.`}
          </P>
        </Pressable>
      )}

      {isFullSwing ? (
        <Btn mt={20} mb={30} bg="#3369FF" rounded={4} onPress={AcceptTnc}>
          <P lh={56} ta="center" fontFamily="DavisSans-Medium">Accept</P>
        </Btn>
      ) : (
        <Div row mb={86}>
          <Button
            text="Cancel" w={190} h={63} bg="transparent" borderWidth={1} borderColor="white" onPress={props.goBack}
            fontSize={20} color="white" flex={1}
          />

          <Div w={10}/>

          <Button
            text={step === 1 ? 'Proceed' : 'Next'} w={190} h={63} onPress={AcceptTnc} bg={colors.newGreenText}
            color={colors.mainBackground} fontSize={20} flex={1}
          />
        </Div>
      )}
    </Div>
  );
};

export default React.memo(TermsConditions);
